export default "__VITE_ASSET__ccb113cf__"